const { eod } = require('@/classes');

module.exports = {
    routes: [
        {
            path: '/dashboard/home',
            name: 'dashboards',
            component: () => import('./views/detail.vue'),
            meta: {
                permissions: ['dashboard.read'],
                isHome: true // Property to know if the dashboard is homepage
            }
        }, {
            path: '/dashboard/:id',
            name: 'dashboard',
            component: () => import('./views/detail.vue'),
            meta: {
                permissions: ['dashboard.read']
            },
            beforeEnter: async (to, from, next) => {

                if (to.params.id == 'generated') {
                    return next();
                }

                // Check permission dashboard through 'templates' endpoint
                const template = await eod.get('templates', ['id'], {
                    where: [{
                        column: 'id',
                        operator: '=',
                        value: to.params.id
                    }]
                }).then(response => {
                    if (response.data.data.templates && response.data.data.templates.edges[0]) {
                        return response.data.data.templates.edges[0];
                    }

                    return null;
                }).catch(() => {
                    return null;
                });

                if (template) {
                    return next();
                }

                return next({ name: '403' });
            }
        },
        {
            path: '/dashboard/project/:id',
            name: 'dashboard.project',
            component: () => import('./views/detail.vue'),
            beforeEnter: async (to, from, next) => {
                // Check if access to project
                const projectsCheck = await eod.getById('project', to.params.id, ['id']).then(response => {
                    if (response.data.data && response.data.data.project) {
                        return true;
                    }

                    return false;
                }).catch(() => { return false; });

                if (!projectsCheck) {
                    return next({ name: '403' });
                }

                return next();
            },
            meta: {
                permissions: ['dashboard.read']
            },
        },
        {
            path: '/dashboard/company/:id',
            name: 'dashboard.company',
            component: () => import('./views/detail.vue'),
            beforeEnter: async (to, from, next) => {
                // Check if access to company
                const companyCheck = await eod.getById('company', to.params.id, ['id']).then(response => {
                    if (response.data.data && response.data.data.company) {
                        return true;
                    }

                    return false;
                }).catch(() => { return false; });

                if (!companyCheck) {
                    return next({ name: '403' });
                }

                return next();
            },
            meta: {
                permissions: ['dashboard.read', 'companies.read']
            },
        },
        {
            path: '/dashboard/product/:id',
            name: 'dashboard.product',
            component: () => import('./views/detail.vue'),
            meta: {
                permissions: ['dashboard.read', 'products.devices.read']
            },
            beforeEnter: async (to, from, next) => {

                const product = await eod.getById('product', to.params.id, ['productType{id}', 'project{id, company{id}}'])
                    .then(response => {
                        if (response && response.data.data) {
                            if (!response.data.data.product) {
                                return null;
                            }

                            return response.data.data.product;
                        }

                        return null;
                    }).catch(() => {
                        return null;
                    });

                if (!product) {
                    return next({ name: '403' });
                }

                return next();
            }
        },
        {
            path: '/dashboard/task/:id',
            name: 'dashboard.task',
            component: () => import('./views/detail.vue'),
            meta: {
                permissions: ['dashboard.read', 'tasks.read']
            },
            beforeEnter: async (to, from, next) => {
                // Check permissions;
                const task = await eod.getById('task', to.params.id, ['id']).then(response => {
                    if (response.data.data && response.data.data.task) {
                        return response.data.data.task;
                    }

                    return null;
                }).catch(() => {
                    return null;
                });

                if (!task) {
                    return next({ name: '403' });
                }

                return next();
            }
        },
        {
            path: '/dashboard/jobtype/:id',
            name: 'dashboard.jobtype',
            component: () => import('./views/detail.vue'),
            meta: {
                permissions: ['dashboard.read', 'jobtypes.read']
            },
            beforeEnter: async (to, from, next) => {
                // Check permission dashboard through 'project_id' query param
                const project = await eod.getById('project', to.query.project_id, ['id', 'company{id}']).then(response => {
                    if (response.data.data && response.data.data.project) {
                        return response.data.data.project;
                    }

                    return null;
                }).catch(() => {
                    return null;
                });

                if (!project) {
                    return next({ name: '403' });
                }

                const tabs = await eod.get('dashboardTabs', ['id', 'name'], {
                    limit: 1,
                    dashboardTabs: eod.getDashboardTabsFilter({ company_id: project.company.id, project_id: project.id, job_type_id: to.params.id })
                }).then(response => {
                    if (response?.data?.data?.dashboardTabs) {
                        return response.data.data.dashboardTabs.edges;
                    }

                    return [];
                });

                if (tabs.length > 0) {
                    return next({ name: 'dashboard', params: { id: tabs[0].id }, query: { company_id: project.company.id, project_id: project.id, job_type_id: to.params.id } });
                }

                return next({ name: 'dashboard', params: { id: 'generated' }, query: { company_id: project.company.id, project_id: project.id, job_type_id: to.params.id } });
            }
        },
        {
            path: '/dashboard/create',
            name: 'dashboard.create',
            component: () => import('./views/detail.vue'),
            meta: {
                permissions: ['dashboard.create']
            }
        }],
    types: [
        {
            'icon': 'mdi-clipboard-outline',
            'label': 'Taaktype',
            'endpoint': 'taskTypes',
            'entity': 'taskType',
            'filter': 'tasktype_id'
        },
        {
            'icon': 'mdi-folder-open-outline',
            'label': 'Project',
            'endpoint': 'projects',
            'entity': 'project',
            'filter': 'project_id'
        },
        {
            'icon': 'mdi-file-sign',
            'label': 'Dienst',
            'endpoint': 'services',
            'entity': 'service',
            'filter': 'service_id'
        },
        {
            'icon': 'mdi-office-building-outline',
            'label': 'Bedrijf',
            'endpoint': 'companies',
            'entity': 'company',
            'filter': 'company_id'
        },
        {
            'icon': 'mdi-waveform',
            'label': 'Meetwaarde',
            'endpoint': 'measurementTypes',
            'entity': 'measurementType',
            'filter': 'measurementtype_id'
        }
    ],
    search: [
        {
            'icon': 'mdi-form-select',
            'label': 'Jobtype',
            'type': 'module',
            'settings': {
                'module': 'jobTypes',
                'fields': ['name'],
                'title': '{name}',
            },
            'filter': 'job_type_id'
        },
        {
            'icon': 'mdi-package-variant',
            'label': 'Asset',
            'type': 'module',
            'settings': {
                'module': 'products',
                'fields': ['name'],
                'title': '{name}',
            },
            'filter': 'product_id'
        },
        {
            'icon': 'mdi-package-variant',
            'label': 'Asset type',
            'type': 'module',
            'settings': {
                'module': 'productTypes',
                'fields': ['name'],
                'title': '{name}',
            },
            'filter': 'product_type_id'
        },
        {
            'icon': 'mdi-folder-open-outline',
            'label': 'Project',
            'type': 'module',
            'settings': {
                'module': 'projects',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'project_id'
        },
        {
            'icon': 'mdi-package-variant',
            'label': 'Artikel type',
            'type': 'module',
            'settings': {
                'module': 'articleTypes',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'article_type_id'
        },
        {
            'icon': 'mdi-file-sign',
            'label': 'Dienst',
            'type': 'module',
            'settings': {
                'module': 'services',
                'fields': ['name'],
                'title': '{name}',
            },

            'filter': 'service_id'
        },
        {
            'icon': 'mdi-office-building-outline',
            'label': 'Bedrijf',
            'type': 'module',
            'settings': {
                'module': 'companies',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'company_id'
        },
        {
            'icon': 'mdi-clipboard-outline',
            'label': 'Taak',
            'type': 'module',
            'settings': {
                'module': 'tasks',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'task_id'
        },
        {
            'icon': 'mdi-account-outline',
            'label': 'Eigenaar',
            'type': 'module',
            'settings': {
                'module': 'searchUsers',
                'fields': ['firstName', 'lastName', 'username'],
                'title': '{firstName} {lastName} ({username})',
                'options': {
                    enabled: true
                }
            },

            'filter': 'owner_id'
        },
    ]
}